(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lineup-pilot-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lineup-product-services')) {
customElements.define('lineup-product-services', class extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.form);
    this.variants = JSON.parse(this.querySelector('[data-service-variants]').textContent);
    this.config = JSON.parse(this.querySelector('[data-service-config]').textContent);
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.onVariant = () => requestAnimationFrame(() => this.sync());
    document.addEventListener('variant:update',this.onVariant,{signal:this.signal});
    this.sync(); this.onVariant();
  }
  current() {return this.variants.find(v=>v.id===(this.form?.querySelector('[name="id"]')?.value || this.dataset.variant));}
  sync() {
    if(!this.isConnected)return;
    const current=this.current();if(!current)return;
    const isOrder=current.managed && current.quantity<=0 && current.policy==='continue';
    const productionVendor=['galican','agility level'].includes(this.dataset.vendor);
    const unavailable=!current.available;
    document.querySelectorAll('[data-lineup-shipping-note="'+this.dataset.product+'"]').forEach(note=>{
      note.hidden=isOrder || (current.managed && current.quantity>0 && /beräknas i lager|åter i lager/i.test(note.textContent));
    });
    const stock=this.querySelector('[data-service-stock]');
    stock.hidden=!this.config.showStock || unavailable;
    stock.textContent=isOrder?this.config.order:this.config.inStock;
    stock.dataset.state=isOrder?'order':'stock';
    this.querySelector('[data-service-restock]').hidden=!unavailable;
    this.querySelector('[data-service-order]').hidden=!isOrder || productionVendor;
    const arrival=this.querySelector('[data-service-arrival]');
    // Incoming dates are owned by Shopify transfers/purchase orders, not an external service.
    const expected=current.incomingDate;
    const expectedDate=/^\d{4}-\d{2}-\d{2}$/.test(expected || '')?new Date(expected+'T00:00:00'):null;
    arrival.hidden=productionVendor || !isOrder || !current.incoming || !expectedDate || !Number.isFinite(expectedDate.getTime());
    arrival.textContent=arrival.hidden?'':this.config.arrival+new Intl.DateTimeFormat(this.dataset.locale,{day:'numeric',month:'long',year:'numeric'}).format(expectedDate);
    if(!arrival.hidden) this.querySelector('[data-service-order]').hidden=true;
    const batch=this.config.sharedProduction?{production_month:this.config.sharedMonth,delivery_month:this.config.sharedDelivery}:this.config.productionSource==='theme'?{production_month:this.config.month,order_deadline:this.config.deadline}:null;
    const box=this.querySelector('[data-service-production]');
    const validMonth=/^\d{4}-\d{2}-\d{2}$/.test(batch?.production_month || '') && Number.isFinite(new Date(batch.production_month+'T00:00:00').getTime());
    box.hidden=!productionVendor || !isOrder || this.config.productionSource==='hide' || !validMonth;
    if(!box.hidden) {
      const date=new Date(batch.production_month+'T00:00:00');
      this.querySelector('[data-production-month]').textContent=new Intl.DateTimeFormat(this.dataset.locale,{month:'long',year:'numeric'}).format(date);
      const delivery=this.querySelector('[data-production-delivery]');
      const deliveryDate=/^\d{4}-\d{2}-01$/.test(batch.delivery_month || '')?new Date(batch.delivery_month+'T00:00:00'):null;
      delivery.hidden=!deliveryDate || !Number.isFinite(deliveryDate.getTime());
      delivery.textContent=delivery.hidden?'':this.config.deliveryLabel+new Intl.DateTimeFormat(this.dataset.locale,{month:'long',year:'numeric'}).format(deliveryDate);
      const deadline=this.querySelector('[data-production-deadline]');
      const target=batch.order_deadline?new Date(batch.order_deadline+'T23:59:59'):null;
      deadline.hidden=!target || !Number.isFinite(target.getTime()) || target<new Date();
      deadline.textContent=deadline.hidden?'':this.config.deadlineLabel+new Intl.DateTimeFormat(this.dataset.locale,{day:'numeric',month:'long'}).format(target);
    }
    const orderKind=this.querySelector('[data-lineup-order-kind]');
    const orderDelivery=this.querySelector('[data-lineup-order-delivery]');
    if(orderKind && orderDelivery){
      const delivery=!box.hidden?this.config.production_property+this.querySelector('[data-production-month]').textContent+(this.querySelector('[data-production-delivery]').hidden?'':' · '+this.querySelector('[data-production-delivery]').textContent):!arrival.hidden?arrival.textContent:this.querySelector('[data-service-order]').textContent.trim();
      orderKind.value=this.config.order;
      orderKind.disabled=!isOrder || unavailable;
      orderDelivery.value=delivery;
      orderDelivery.disabled=!isOrder || unavailable || !delivery;
    }
    const deliveryData=this.querySelector('[data-lineup-delivery-data]');
    deliveryData.disabled=!isOrder || unavailable;
    deliveryData.value=JSON.stringify({kind:'made_to_order',production_month:box.hidden?null:batch.production_month,delivery_month:box.hidden?null:batch.delivery_month || null});
    const button=this.form?.querySelector('button[type="submit"]');
    if(button){if(unavailable){button.hidden=true;button.dataset.lineupUnavailable='true';}else if(button.dataset.lineupUnavailable){button.hidden=false;delete button.dataset.lineupUnavailable;}}
    this.lastVariant=current.id;
  }
  disconnectedCallback(){this.controller?.abort();}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lineup-review-panel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lineup-review-panel'))customElements.define('lineup-review-panel',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
    this.setupReviewLanguage();this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('.lu-review-trigger');if(!this.dialog||!this.trigger)return;
    this.trigger.addEventListener('click',()=>{this.lastOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';},options);
    this.querySelector('.lu-review-close').addEventListener('click',()=>this.dialog.close(),options);
    // Judge.me mounts its writing flow outside this native modal; release the modal before that flow opens.
    this.addEventListener('click',event=>{const action=event.composedPath().find(node=>node instanceof Element&&node.matches('button,a'));const label=action?.textContent?.trim()||'';if(action&&(action.matches('[data-testid="write-review-button"],[class*="write"]')||/write a review|skriv en|kirjoita arvostelu|bewertung schreiben|crire un avis|rakst.t atsauksmi|ra.yti atsiliepim|kirjuta arvustus/i.test(label))&&this.dialog.open)this.pendingReview=true;},{...options,capture:true});
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const b=this.dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();}},options);
    this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.lastOverflow||'';if(this.trigger.isConnected)this.trigger.focus({preventScroll:true});},options);
    this.trigger.disabled=false;this.dataset.ready='true';
  }
  setupReviewLanguage(){
    // Theme-local fallback for Judge.me's stale language registry (including Shopify nb).
    // Only English UI labels are replaced; customer review content and names are excluded.
    const data=JSON.parse(this.querySelector('.lu-review-i18n').textContent);const locale=this.dataset.locale||'en';
    const titles={sv:'Recensioner',da:'Anmeldelser',nb:'Anmeldelser',no:'Anmeldelser',en:'Reviews',fi:'Arvostelut',de:'Bewertungen',fr:'Avis',lv:'Atsauksmes',lt:'Atsiliepimai',et:'Arvustused'};
    this.querySelector('.lu-review-header h2').textContent=titles[locale]||titles.en;
    this.querySelector('.lu-review-trigger .visually-hidden').textContent=titles[locale]||titles.en;
    this.querySelector('.lu-review-close').setAttribute('aria-label',data.text.Close);
    const translate=value=>{
      const key=value.trim();if(/^[0-5]\.\d{1,2}$/.test(key))return new Intl.NumberFormat(locale,{maximumFractionDigits:2}).format(Number(key));if(key.startsWith('Sorted by '))return `${data.text['Sort by']}: ${translate(key.slice(10))}`;if(data.text[key])return value.replace(key,data.text[key]);
      let match=key.match(/^(\d+) reviews?$/);if(match)return `${match[1]} ${new Intl.PluralRules(locale).select(Number(match[1]))==='one'?data.units[0]:(locale==='lt'&&new Intl.PluralRules(locale).select(Number(match[1]))==='other'?'atsiliepimų':data.units[1])}`;
      match=key.match(/^(\d+) stars?$/);if(match)return `${match[1]} ${data.units[Number(match[1])===1?2:3]}`;
      match=key.match(/^(\d+) out of 5 stars$/);if(match){const labels={sv:`${match[1]} av 5 stjärnor`,da:`${match[1]} ud af 5 stjerner`,nb:`${match[1]} av 5 stjerner`,fi:`${match[1]}/5 tähteä`,de:`${match[1]} von 5 Sternen`,fr:`${match[1]} étoiles sur 5`,lv:`${match[1]} no 5 zvaigznēm`,lt:`${match[1]} iš 5 žvaigždučių`,et:`${match[1]}/5 tärni`};return labels[locale]||key;}
      return value;
    };
    const excluded='.jm-review-content__body,.jm-review-content__title,.jdgm-rev__body,.jdgm-rev__title,[class*="reviewer-name"],[class*="author"],script,style,textarea,input';
    const update=root=>{
      for(const stars of root.querySelectorAll('.jdgm-write-review-modal__stars')){stars.dataset.luPoor=data.text.Poor;stars.dataset.luGreat=data.text.Great;}
      const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
      while(node=walker.nextNode()){if(node.parentElement?.closest(excluded))continue;const next=translate(node.textContent);if(next!==node.textContent)node.textContent=next;}
      for(const el of [root,...root.querySelectorAll('[aria-label],[placeholder],[title]')]){
        if(el.closest(excluded)&&!el.matches('input,textarea'))continue;
        for(const attr of ['aria-label','placeholder','title']){const value=el.getAttribute(attr);if(value){const next=translate(value);if(next!==value)el.setAttribute(attr,next);}}
      }
    };
    this.languageObserver?.disconnect();this.portalObserver?.disconnect();this.writeFlowObserver?.disconnect();
    this.writeFlowObserver=new MutationObserver(()=>{if(this.pendingReview&&this.dialog?.open){for(const form of document.querySelectorAll('.jdgm-write-review-modal')){if(getComputedStyle(form).display!=='none'){this.pendingReview=false;this.dialog.close();break;}}}});
    this.languageObserver=new MutationObserver(()=>{for(const root of this.languageRoots)if(root.isConnected)update(root);});
    this.languageRoots=new Set();
    const observe=root=>{if(!root||this.languageRoots.has(root))return;this.languageRoots.add(root);if(root.matches('.jdgm-write-review-modal'))this.writeFlowObserver.observe(root,{attributes:true,attributeFilter:['style','class','hidden']});update(root);this.languageObserver.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','placeholder','title']});};
    observe(this.querySelector('.lu-review-body'));
    for(const root of document.querySelectorAll('.jdgm-write-review-modal'))observe(root);
    this.portalObserver=new MutationObserver(()=>{for(const root of document.querySelectorAll('.jdgm-write-review-modal'))observe(root);});
    this.portalObserver.observe(document.body,{childList:true});
    const number=this.querySelector('.lu-review-trigger>span:first-child');if(number)number.textContent=new Intl.NumberFormat(locale,{maximumFractionDigits:1}).format(Number(number.textContent));
  }
  disconnectedCallback(){this.languageObserver?.disconnect();this.portalObserver?.disconnect();this.writeFlowObserver?.disconnect();this.writeFlowObserver?.disconnect();
    this.writeFlowObserver=new MutationObserver(()=>{if(this.pendingReview&&this.dialog?.open){for(const form of document.querySelectorAll('.jdgm-write-review-modal')){if(getComputedStyle(form).display!=='none'){this.pendingReview=false;this.dialog.close();break;}}}});if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.lastOverflow||'';}this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Enhance the Shopify size guide table; retain the legacy table fallback for unassigned products.
  if (!customElements.get('lineup-size-guide')) {
    customElements.define('lineup-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.updateSize(this.dataset.selectedSize);
        this.closest('variant-picker')?.addEventListener('variant:update', () => {
          this.updateSize(this.dataset.selectedSize);
        }, { signal: this.controller.signal });
        this.closest('variant-picker')?.addEventListener('change', event => {
          const input = event.target;
          if (input instanceof HTMLInputElement && input.dataset.fieldsetIndex === this.dataset.optionIndex) {
            this.updateSize(input.value);
          } else if (input instanceof HTMLSelectElement && input.name === `options[${this.dataset.optionName}]`) {
            this.updateSize(input.value);
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      updateSize(size) {
        const rows = [...(this.querySelector('table')?.rows || [])];
        const normalise = value => String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
        const headers = rows[0] ? [...rows[0].cells].map(cell => cell.textContent.trim()) : [];
        const row = rows.slice(1).find(row => normalise(row.cells[0]?.textContent) === normalise(size));
        const selection = this.querySelector('.lineup-size-guide__selection');
        const help = this.querySelector('.lineup-size-guide__help');
        rows.forEach(item => item.toggleAttribute('data-current-size', item === row));
        selection.replaceChildren();
        selection.hidden = !row;
        help.hidden = !row || !help.textContent.trim() || (this.dataset.structured !== 'true' && row.cells.length !== 3);
        if (!row) return;
        const title = document.createElement('strong');
        title.textContent = `${this.dataset.optionName} ${size}`;
        selection.append(title);
        [...row.cells].slice(1).forEach((cell, index) => {
          let label = headers[index + 1] || '';
          if (this.dataset.structured !== 'true' && /^(nackomkrets|halsomkrets|neck circumference|neck)$/i.test(label)) label = this.dataset.neckLabel;
          if (this.dataset.structured !== 'true' && /^(bröstomkrets|chest circumference|chest)$/i.test(label)) label = this.dataset.chestLabel;
          const value = document.createElement('strong');
          value.textContent = cell.textContent.trim();
          selection.append(document.createTextNode(` · ${label} `), value);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
